import { Monitor, Moon, Sun } from "lucide-react";
import { useState } from "react";

import { getThemePref, setThemePref, type ThemePref } from "../lib/theme";

const OPTIONS: { value: ThemePref; label: string; Icon: typeof Sun }[] = [
	{ value: "light", label: "Light", Icon: Sun },
	{ value: "dark", label: "Dark", Icon: Moon },
	{ value: "system", label: "System", Icon: Monitor },
];

export function ThemeToggle() {
	const [pref, setPref] = useState<ThemePref>(() => getThemePref());

	function choose(next: ThemePref) {
		setPref(next);
		setThemePref(next);
	}

	return (
		<div
			role="radiogroup"
			aria-label="Colour theme"
			className="inline-flex rounded-lg border border-hairline bg-ground p-0.5"
		>
			{OPTIONS.map(({ value, label, Icon }) => (
				<button
					key={value}
					type="button"
					role="radio"
					aria-checked={pref === value}
					onClick={() => choose(value)}
					className={`inline-flex min-h-tap items-center gap-1.5 rounded-md px-2.5 text-xs sm:h-7 sm:min-h-0 ${
						pref === value
							? "bg-paper font-semibold text-ink shadow-[0_1px_2px_rgba(6,9,18,0.12)]"
							: "text-muted hover:text-ink"
					}`}
				>
					<Icon className="size-3.5" aria-hidden />
					{label}
				</button>
			))}
		</div>
	);
}
